import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';

import { AppRoutes } from '@gfe/app.paths';

import { selectAuthChecked, selectUser } from '@core/store/auth/auth.selectors';

export const guestGuard: CanActivateFn = () => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select(selectAuthChecked).pipe(
    filter((checked) => checked),
    take(1),
    map(() => {
      const user = store.selectSignal(selectUser);
      if (!user()) return true;
      return router.createUrlTree([AppRoutes.home]);
    })
  );
};
